/* PRELOADER */
window.addEventListener('load',()=>{
  setTimeout(()=>{
    const pre=document.getElementById('pre');
    if(!pre)return;
    pre.style.transition='opacity .6s ease';
    pre.style.opacity='0';
    setTimeout(()=>pre.remove(),650);
  },2600);
});

/* CURSOR */
const cur=document.getElementById('cur');
const cur2=document.getElementById('cur2');
let mx=0,my=0,cx2=0,cy2=0;

if(cur&&cur2){
  document.addEventListener('mousemove',e=>{
    mx=e.clientX;my=e.clientY;
    cur.style.left=mx+'px';
    cur.style.top=my+'px';
  });
  (function animCur2(){
    cx2+=(mx-cx2)*.12;
    cy2+=(my-cy2)*.12;
    cur2.style.left=cx2+'px';
    cur2.style.top=cy2+'px';
    requestAnimationFrame(animCur2);
  })();
  document.querySelectorAll('a,button,.hcard,.phil-card,.col-card').forEach(el=>{
    el.addEventListener('mouseenter',()=>document.body.classList.add('h'));
    el.addEventListener('mouseleave',()=>document.body.classList.remove('h'));
  });
}

/* TICKER DUPLICATE */
const tt=document.getElementById('tt');
if(tt)tt.innerHTML+=tt.innerHTML;

/* SCROLL REVEAL */
const obs=new IntersectionObserver(entries=>{
  entries.forEach(e=>{if(e.isIntersecting)e.target.classList.add('on');});
},{threshold:.08});
document.querySelectorAll('.rv').forEach(el=>obs.observe(el));

/* FOUNDER STRIKE */
const strikeObs=new IntersectionObserver(entries=>{
  entries.forEach(e=>{
    if(e.isIntersecting)setTimeout(()=>e.target.classList.add('on'),600);
  });
},{threshold:.5});
document.querySelectorAll('.strike').forEach(el=>strikeObs.observe(el));

/* MOBILE NAV TOGGLE */
const navToggle=document.getElementById('nav-toggle');
const navMenu=document.getElementById('nav-menu');
if(navToggle&&navMenu){
  navToggle.addEventListener('click',()=>{
    navToggle.classList.toggle('active');
    navMenu.classList.toggle('open');
  });
  navMenu.querySelectorAll('a').forEach(link=>{
    link.addEventListener('click',()=>{
      navToggle.classList.remove('active');
      navMenu.classList.remove('open');
    });
  });
}

/* HORIZONTAL DRAG SCROLL */
const hs=document.getElementById('hs');
if(hs){
  let isDown=false,startX,scrollLeft;
  hs.addEventListener('mousedown',e=>{
    isDown=true;startX=e.pageX-hs.offsetLeft;scrollLeft=hs.scrollLeft;
    hs.style.cursor='grabbing';
  });
  hs.addEventListener('mouseleave',()=>{isDown=false;hs.style.cursor='grab';});
  hs.addEventListener('mouseup',()=>{isDown=false;hs.style.cursor='grab';});
  hs.addEventListener('mousemove',e=>{
    if(!isDown)return;
    e.preventDefault();
    const x=e.pageX-hs.offsetLeft;
    hs.scrollLeft=scrollLeft-(x-startX)*1.6;
  });
}
